import React, { Component, location, history } from 'react';
import { observer } from 'mobx-react/dist/mobx-react';
import { ChromePicker, CirclePicker, TwitterPicker } from 'react-color';
import { Placeholder } from 'semantic-ui-react';
import { FirestoreDocument, withFirestore } from 'react-firestore';

// components
import ViewerSettingsHeader from '../ViewerSettingsHeader';
import ViewerMenu from '../ViewerMenu';


// symbols
import ColorSymbol from '../../../images/noun_drop_1235520.svg'






const ColorAndtextureSettings = observer(class ColorAndtextureSettings extends Component {

  state = {
    background: '#fff',
    panel: "object",
    isLoading: true,
    isLoadingEnv: true,
    objName: "",
    modifiers: [],
    preview: "",
    transformTool: "Rotate",
    standardMods: undefined
  };

  downloadedElements = {};
  currentRotationCommand = undefined;

  handleChangeComplete(color, i) {
    var newModifiers = this.state.modifiers;
    console.log('state modifiers: ', this.state.modifiers);
    newModifiers[i].options.defaultColor = color.hex;
    this.setState({ modifiers: newModifiers });

    if(this.state.modifiers[i].type === "materialEdit"){
      // todo create for all modifiers
      var currModifiers = [
        {
          "type": this.state.modifiers[i].type,
          "options": ["materialName="+this.state.modifiers[i].options.materialName, "isColorChangeable="+this.state.modifiers[i].options.isColorChangeable,"defaultColor=" + color.hex]
        }
      ];

      this.unityContent.send('ModifierManager', 'applyModifierToSelectedObject', JSON.stringify(currModifiers));
    }

  };


  toggleColorpicker(i){
    var newModifiers = this.state.modifiers;
    newModifiers[i].colorPickerOpen = newModifiers[i].colorPickerOpen ? false : true;
    this.setState({ modifiers: newModifiers });
  }


  constructor(props){
    super(props);
    this.unityContent = this.props.unityContent;


    this.unityContent.on("onUserHasInteractionToolChanged", (argument) => {
      // console.log('TOOL CHANGED: ', argument);
      this.changeTransformTool(argument)
    });

    // this is used to reset the rotation and to flip it
    this.unityContent.on("selectedObjectsTransformationData", (data) => {
      let dataArray = data.split(',');
      var currentTransforms = {
        rotation: {
          x: dataArray[3],
          y: dataArray[4],
          z: dataArray[5]
        },
        move: {
          x: dataArray[0],
          y: dataArray[1],
          z: dataArray[2]
        },
        scale: {
          x: dataArray[6],
          y: dataArray[7],
          z: dataArray[8]
        }
      };

      if(this.currentRotationCommand === "resetRotation" || this.currentRotationCommand === "flipUp") {
        if (this.currentRotationCommand === "resetRotation") {
          currentTransforms.rotation.x = 0;
          currentTransforms.rotation.y = 0;
          currentTransforms.rotation.z = 0;
        } else if (this.currentRotationCommand === "flipUp") {
          currentTransforms.rotation.x = -90;
          currentTransforms.rotation.y = 0;
          currentTransforms.rotation.z = 0;
        }

        const currTransforms = `${currentTransforms.move.x}, ${currentTransforms.move.y}, ${currentTransforms.move.z}, ${currentTransforms.rotation.x}, ${currentTransforms.rotation.y}, ${currentTransforms.rotation.z}, ${currentTransforms.scale.x}, ${currentTransforms.scale.y}, ${currentTransforms.scale.z}`
        this.unityContent.send("SceneRecreator", "setPositionRotationScaleForSelectedObject", currTransforms);
      }


      this.currentRotationCommand = undefined;

    });

  }

  updateObjectTransforms(type){
    this.currentRotationCommand = type;
    this.unityContent.send("SceneRecreator", "sendSelectedObjectTransformationDataViaExternalFunction");
  }


  changeGravity(){
    // this.props.handleGeneralSettings('gravity', !this.props.viewerState.gravity);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.selectedObj !== this.props.selectedObj) {
      console.log('CURR MODIFIERS: ', this.props.selectedObj.modifiers);

      this.setState({ isLoading: true });
      console.log("downloadedElements: ", this.downloadedElements);
      if (this.downloadedElements[this.props.selectedObj.firebaseId]) {
        console.log('this element has already been downloaded, load from store');
        this.setCurrObjectData(this.props.selectedObj.firebaseId);
      } else {
        const { firestore } = this.props;
        const currentCollection = this.props.selectedObj.type == "obj" ? "Objects" : "Products";
        firestore.doc(currentCollection + '/' + this.props.selectedObj.firebaseId).onSnapshot(snapshot => {
          var currObjectData = snapshot.data();
          currObjectData.modifiers = this.createModifierForObj(currObjectData.modifiers, this.props.selectedObj.modifiers);
          console.log('Information About OBJ: ', snapshot.data());

          this.downloadedElements[this.props.selectedObj.firebaseId] = currObjectData;
          this.setCurrObjectData(this.props.selectedObj.firebaseId);
        });
      }
    }
  }

  createModifierForObj(firebaseModifiers, unityModifiers){
    firebaseModifiers = this.createJavascriptModifier(firebaseModifiers || []);
    unityModifiers = this.createJavascriptModifier(unityModifiers || []);

    for (var i = 0; i<firebaseModifiers.length; i++){
      if(firebaseModifiers[i].type === "materialEdit"){
        for (var j = 0; j<unityModifiers.length; j++){
          if(firebaseModifiers[i].options.materialName === unityModifiers[j].options.materialName){
            firebaseModifiers[i].options.defaultColor = unityModifiers[j].options.defaultColor;
          }
        }
      }
    }

    return firebaseModifiers;
  }

  createJavascriptModifier(modifiers){
    var javascriptModifiers = [];
    for (var i = 0; i<modifiers.length; i++){
      modifiers[i].options = this.modifierOptionsToProperties(modifiers[i].options);
      javascriptModifiers.push(modifiers[i]);
    }
    return javascriptModifiers;
  }

  modifierOptionsToProperties(options){
    var returnOption = {};
    for(var i = 0; i<options.length; i++){
      const currOption = options[i].split("=");
      returnOption[currOption[0]] = currOption[1];
    }
    return returnOption;
  }

  setCurrObjectData(firebaseId){
    const currMod = this.state.standardMods ? this.state.standardMods :  this.downloadedElements[firebaseId].modifiers.map(a => a.options.defaultColor);;

    this.setState({
      objName: this.downloadedElements[firebaseId].name,
      preview: this.downloadedElements[firebaseId].preview,
      modifiers: this.downloadedElements[firebaseId].modifiers,
      isLoading: false,
      standardMods: currMod || []
    });
  }

  changeTransformTool(tool){
    // CameraController -> OnToolChanged(tool). Mögliche Parameter: ‘Rotate’, ‘Move’, ‘None’, ‘Scale’, ‘View’
    this.unityContent.send("CameraController", "OnToolChanged", tool);
    this.setState({ transformTool: tool });
  }

  componentDidMount() {
  }

  deleteCurrSelection(){
    this.props.deleteSelected("Delete Selection");
  }


  render() {

    return(
          <div className={" " +(this.props.isActive ? "" : "hidden")} >
            <div>
              <div className="objectinformationtab">
                <div className="objectimagecontainer">
                  {this.state.isLoading ? (
                    <Placeholder>
                      <Placeholder.Image square />
                    </Placeholder>
                  ) : (
                    <img src={this.state.preview} alt="" className="image-12" />
                  )}
                </div>
                <div className="objectinformationtextcontainer">
                  { this.state.isLoading ? (
                    <Placeholder>
                      <Placeholder.Header />
                      <Placeholder.Line />
                    </Placeholder>
                  ) : (
                    <div>
                      <div className="objectinformationtype">{this.props.selectedObj.type == "obj" ? "Object" : "Product"}</div>
                      <h3 className="objectinformationname">{this.state.objName}</h3>
                    </div>
                  )}
                </div>
              </div>

              <div className="propertycontainer">
                <div className="propertyelementcontainer">
                  <div className={"rotationbuttoncontainer withtext first " + (this.state.transformTool === "Rotate" ? "active" : "")} onClick={() => this.changeTransformTool("Rotate")}>
                    <div className="html-embed w-embed">
                      <span dangerouslySetInnerHTML={{__html: "<svg height=\"20px\" width=\"20px\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\"\n" +
                        "                           viewBox=\"0 0 60 68\" x=\"0px\" y=\"0px\">\n" +
                        "                        <path fill=\"currentColor\"\n" +
                        "                              d=\"M674,322 C674,321.289835 674.368524,320.57967 675.105573,320.211146 L689.105573,313.211146 C689.668628,312.929618 690.331372,312.929618 690.894427,313.211146 L704.894427,320.211146 C705.631476,320.57967 706,321.289835 706,322 L706,338 C706,338.757544 705.571995,339.45007 704.894427,339.788854 L690.913389,346.779373 C690.377672,347.055315 689.716816,347.094476 689.105573,346.788854 L675.105573,339.788854 C674.428005,339.45007 674,338.757544 674,338 L674,322 Z M699.527864,322 L690,317.236068 L680.472136,322 L690,326.763932 L699.527864,322 Z M678,325.236068 L678,336.763932 L688,341.763932 L688,330.236068 L678,325.236068 Z M702,325.236068 L692,330.236068 L692,341.763932 L702,336.763932 L702,325.236068 Z M689.828427,356 L690,356 C704.359403,356 716,344.359403 716,330 C716,328.895431 716.895431,328 718,328 C719.104569,328 720,328.895431 720,330 C720,346.568542 706.568542,360 690,360 L689.828427,360 L690.414214,360.585786 C691.195262,361.366835 691.195262,362.633165 690.414214,363.414214 C689.633165,364.195262 688.366835,364.195262 687.585786,363.414214 L683.585786,359.414214 C682.804738,358.633165 682.804738,357.366835 683.585786,356.585786 L687.585786,352.585786 C688.366835,351.804738 689.633165,351.804738 690.414214,352.585786 C691.195262,353.366835 691.195262,354.633165 690.414214,355.414214 L689.828427,356 Z M690.171573,304 L690,304 C675.640597,304 664,315.640597 664,330 C664,331.104569 663.104569,332 662,332 C660.895431,332 660,331.104569 660,330 C660,313.431458 673.431458,300 690,300 L690.171573,300 L689.585786,299.414214 C688.804738,298.633165 688.804738,297.366835 689.585786,296.585786 C690.366835,295.804738 691.633165,295.804738 692.414214,296.585786 L696.414214,300.585786 C697.195262,301.366835 697.195262,302.633165 696.414214,303.414214 L692.414214,307.414214 C691.633165,308.195262 690.366835,308.195262 689.585786,307.414214 C688.804738,306.633165 688.804738,305.366835 689.585786,304.585786 L690.171573,304 Z\"\n" +
                        "                              transform=\"translate(-660 -296)\"></path>\n" +
                        "                      </svg>" }} />
                    </div>
                    <div className="text-block-27">Rotation Tool</div>
                  </div>
                  <div className={"rotationbuttoncontainer withtext " + (this.state.transformTool === "Move" ? "active" : "") } onClick={() => this.changeTransformTool("Move")}>
                    <div className="html-embed w-embed">
                      <span dangerouslySetInnerHTML={{__html: "<svg height=\"20px\" width=\"20px\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 512 512\" style=\"enable-background:new 0 0 512 512;\" xml:space=\"preserve\"><g><path d=\"M99.703,329.234c3.561,4.208,8.638,6.373,13.749,6.373c4.108,0,8.238-1.399,11.619-4.261   c7.588-6.422,8.534-17.779,2.112-25.368l-26.767-31.628h135.774v135.868l-31.016-26.248c-7.588-6.422-18.946-5.478-25.368,2.112   c-6.422,7.588-5.477,18.946,2.112,25.368l61.606,52.138c3.355,2.84,7.492,4.26,11.628,4.26s8.272-1.42,11.628-4.26l61.606-52.138   c7.588-6.422,8.534-17.779,2.112-25.368c-6.422-7.589-17.78-8.534-25.368-2.112l-32.941,27.878V274.351h137.7l-26.766,31.628   c-6.422,7.588-5.477,18.946,2.112,25.368c3.381,2.862,7.511,4.261,11.619,4.261c5.111,0,10.188-2.166,13.749-6.373l52.138-61.606   c5.68-6.711,5.68-16.544,0-23.256l-52.138-61.606c-6.421-7.589-17.78-8.534-25.368-2.112c-7.588,6.422-8.534,17.779-2.112,25.368   l27.36,32.329H272.191V100.152l32.941,27.878c3.381,2.862,7.511,4.261,11.619,4.261c5.111,0,10.188-2.166,13.749-6.373   c6.422-7.588,5.477-18.946-2.112-25.368l-61.606-52.138c-6.711-5.681-16.545-5.681-23.256,0l-61.606,52.138   c-7.588,6.422-8.534,17.779-2.112,25.368c6.422,7.589,17.781,8.535,25.368,2.112l31.016-26.248v136.569H99.823l27.36-32.329   c6.422-7.588,5.476-18.946-2.112-25.368c-7.588-6.422-18.946-5.477-25.368,2.112l-52.137,61.606c-5.68,6.711-5.68,16.544,0,23.256   L99.703,329.234z\"></path></g>\n" +
                        "</svg>" }} />
                    </div>
                    <div className="text-block-27">Move Tool</div>
                  </div>
                </div>

                <div className="propertyelementcontainer">
                  <div className="rotationbuttoncontainer first " onClick={() => {this.updateObjectTransforms("resetRotation")}} >
                    <div className="html-embed w-embed">
                    <span dangerouslySetInnerHTML={{__html: "<svg height=\"20px\" width=\"20px\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 100 100\" style=\"enable-background:new 0 0 100 100;\" xml:space=\"preserve\"><path d=\"M34.723,8.185C30.065,10.513,27.5,13.822,27.5,17.5v65c0,3.678,2.565,6.987,7.223,9.315c4.213,2.106,9.744,3.16,15.277,3.16  c5.532,0,11.065-1.054,15.277-3.16c4.657-2.329,7.223-5.637,7.223-9.315v-65c0-3.678-2.565-6.987-7.223-9.315  C56.852,3.972,43.146,3.972,34.723,8.185z M67.5,82.5c0,1.661-1.625,3.427-4.459,4.844c-7.068,3.534-19.014,3.534-26.082,0  C34.125,85.927,32.5,84.161,32.5,82.5V25.52c0.678,0.458,1.417,0.893,2.223,1.295c4.213,2.106,9.744,3.16,15.277,3.16  c5.532,0,11.065-1.054,15.277-3.16c0.806-0.403,1.545-0.837,2.223-1.295V82.5z M67.5,17.5c0,1.661-1.625,3.427-4.459,4.844  c-7.068,3.534-19.014,3.534-26.082,0C34.125,20.927,32.5,19.161,32.5,17.5s1.625-3.427,4.459-4.844  c3.534-1.767,8.288-2.651,13.041-2.651s9.507,0.884,13.041,2.651C65.875,14.073,67.5,15.839,67.5,17.5z\"></path></svg>\n"}}
                    />
                    </div>
                  </div>
                  <div className="rotationbuttoncontainer" onClick={() => {this.updateObjectTransforms("flipUp")}}>
                    <div className="html-embed smaller w-embed">
                    <span dangerouslySetInnerHTML={{__html: "<svg height=\"17px\" width=\"17px\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\"\n" +
                      "                     viewBox=\"0 0 68 40\" x=\"0px\" y=\"0px\">\n" +
                      "                  <path fill=\"currentColor\" fill-rule=\"evenodd\"\n" +
                      "                        d=\"M428.007011,829.999997 L428,830 C421.056225,830 416,820.898795 416,810 C416,799.101205 421.056225,790 428,790 L472,790 C478.943775,790 484,799.101205 484,810 C484,820.898795 478.943775,830 472,830 L428.007011,830 L428.007011,829.999997 Z M428,826 C432.10192,826 436,818.983456 436,810 C436,801.016544 432.10192,794 428,794 C423.89808,794 420,801.016544 420,810 C420,818.983456 423.89808,826 428,826 Z M472,826 C476.10192,826 480,818.983456 480,810 C480,801.016544 476.10192,794 472,794 L435.302688,794 C438.212146,797.673939 440,803.519161 440,810 C440,816.480575 438.212254,822.325953 435.302612,826 L472,826 Z\"\n" +
                      "                        transform=\"translate(-416 -790)\"></path>\n" +
                      "                </svg>"}} />
                    </div>
                  </div>
                </div>

                { this.state.isLoading ? (
                  <div className="propertycontainer">
                    <Placeholder>
                      <Placeholder.Header/>
                      <Placeholder.Line/>
                      <Placeholder.Line/>
                    </Placeholder>
                    <Placeholder>
                      <Placeholder.Header/>
                      <Placeholder.Line/>
                      <Placeholder.Line/>
                    </Placeholder>
                  </div>
                ) : (
                  <div className="propertycontainer">
                    {this.state.modifiers.map((modifier, i) => {
                      return (
                        <div className="propertycontainer">
                          <div className="div-block-9">
                            <div className="propertytitle no-margin">{modifier.modifierViewerText  || ("Material" + (i+1) )}</div>
                            {modifier.colorPickerOpen ? (<div className="colorlink" onClick={ () => { this.toggleColorpicker(i)} }>close</div>) : (<div className="colorlink" onClick={ () => { this.toggleColorpicker(i)} }>+ custom Color</div>) }
                          </div>

                          <CirclePicker color={ modifier.options.defaultColor || "#ffffff" } colors={ modifier.colorRec || [] }
                                        onChangeComplete={ (color) => (this.handleChangeComplete(color, i)) }/>

                          { modifier.colorPickerOpen && (
                            <div>
                              <ChromePicker disableAlpha={true} color={ modifier.options.defaultColor || "#ffffff" }
                                            onChangeComplete={ (color) => (this.handleChangeComplete(color, i)) }/>
                            </div>

                          )}
                        </div>
                      );
                    })}

                  </div>
                )
                }
              </div>
            </div>
            <div className="objectpaneldeletebutton" onClick={ () => { this.props.onPress("Delete Selection") } }>
              <div>DELETE</div>
            </div>
          </div>
    )
  }
});


export default withFirestore(ColorAndtextureSettings);
